var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 759.03351,
    height: 859.9751,
    viewBox: "0 0 759.03351 859.9751",
    fill: "none",
    id: "svg74",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9405_17331)",
    id: "g2",
    transform: "translate(-243.97664,-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 851.469,533.617 c 0,0 -105.751,16.611 -189.98,-31.257 C 587.906,460.542 490.562,367.658 441,319.002 c -5.603,-4.495 -40.68,-34.099 -87.816,-15.826 -47.135,18.274 -53.502,77.174 -54.945,81.502 L 278,537.002 c 8,-21 19.208,-32.808 41.332,-35.212 29.34,-3.367 68.089,34.821 69.532,36.744 58.678,58.668 119.653,121.858 178.331,180.529 14.651,12.208 27.244,19.903 57.081,19.903 29.838,0 42.504,-15.099 48.276,-19.903 28.858,-28.856 178.917,-185.446 178.917,-185.446 z",
    fill: "#0284fe",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 851.469,533.617 c 0,0 -105.751,16.611 -189.98,-31.257 C 587.906,460.542 490.562,367.658 441,319.002 c -5.603,-4.495 -40.68,-34.099 -87.816,-15.826 -47.135,18.274 -53.502,77.174 -54.945,81.502 L 277.5,541.002 c 7.215,-21.64 19.708,-36.808 41.832,-39.212 29.34,-3.367 68.089,34.821 69.532,36.744 58.678,58.668 119.653,121.858 178.331,180.529 14.651,12.208 27.244,19.903 57.081,19.903 29.838,0 42.504,-15.099 48.276,-19.903 28.858,-28.856 178.917,-185.446 178.917,-185.446 z",
    fill: "#0284fe",
    id: "path2"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_9405_17331)",
    id: "g3",
    transform: "translate(-243.97664,-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 851.503,530.992 c 0,0 -106.988,18.19 -191.214,-29.678 C 586.706,459.495 500.829,376.387 441,319.001 c -7.631,-6.105 -43.524,-32.971 -87.48,-15.93 -47.135,18.274 -53.807,77.174 -55.25,81.502 L 278,540.501 c 7.215,-21.64 12.116,-41.901 34.241,-44.306 29.339,-3.366 58.872,23.496 84.625,49.244 25.948,25.943 49.556,49.736 74.134,75.062 31.002,31.944 62.958,65.422 96.5,98.623 13.736,11.905 26.781,20.325 57.082,19.841 28.377,-0.477 41.818,-14.953 48.839,-21.058 28.859,-28.855 178.082,-186.915 178.082,-186.915 z",
    fill: "url(#paint0_radial_9405_17331)",
    fillOpacity: 0.4,
    id: "path3",
    style: {
      fill: "url(#paint0_radial_9405_17331)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 122.97436,499.081 c 0,0 -30.830998,-31.746 -64.407998,-14.651 -17.524,9.893 -24.115,34.798 -24.115,34.798 L 0.26336176,772.278 c 0,0 -10.19200006,77.58 96.23000024,86.643 100.044998,8.517 104.929998,-58.866 104.929998,-58.866 l 25.945,-194.136 z",
    fill: "url(#paint1_radial_9405_17331)",
    id: "path4",
    style: {
      fill: "url(#paint1_radial_9405_17331)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 132.12836,508.544 c 213.33,52.736 312.844,-104.965 418.792,-208.996 5.904,-5.798 44.1,-27.806 91.082,-9.588 46.982,18.218 60.4,65.857 61.838,70.171 l 24.086,182.045 c -7.19,-21.573 -43.097,-38.401 -72.983,-38.401 -29.242,-3.356 -47.327,19.946 -48.765,21.864 -58.486,58.487 -114.704,116.383 -173.191,174.873 -5.274,4.314 -22.49,24.936 -52.691,24.452 -28.284,-0.477 -43.04,-5.185 -61.355,-24.452 -29.243,-28.766 -158.049,-163.203 -186.813,-191.968 z",
    fill: "url(#paint2_radial_9405_17331)",
    id: "path5",
    style: {
      fill: "url(#paint2_radial_9405_17331)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 54.289362,370.574 c 0,0 10.073,-87.302 84.553998,-87.302 35.179,-0.271 56.179,19.729 56.179,19.729 l 74.468,70.32 66.805,57.968 c -113.138,25.198 -166.367,21.458 -282.005998,-60.715 z",
    fill: "url(#paint3_radial_9405_17331)",
    fillOpacity: 0.9,
    id: "path6",
    style: {
      fill: "url(#paint3_radial_9405_17331)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 230.72236,148.044 C 230.72236,66.2814 297.68136,3.8155175e-8 380.27836,3.8155175e-8 462.87436,3.8155175e-8 529.83536,66.2814 529.83536,148.044 c 0,15.931 -3.789,59.503 -51.517,122.597 -47.726,63.094 -86.408,109.585 -98.04,109.585 -11.633,0 -56.499,-46.491 -99.704,-109.585 -43.205,-63.094 -49.852,-106.666 -49.852,-122.597 z m 152.091,49.675 c 36.399,0 65.907,-30.075 65.907,-67.173 0,-37.099 -29.508,-67.1736 -65.907,-67.1736 -36.398,0 -65.905,30.0746 -65.905,67.1736 0,37.098 29.507,67.173 65.905,67.173 z",
    fill: "url(#paint4_radial_9405_17331)",
    id: "path7",
    style: {
      fill: "url(#paint4_radial_9405_17331)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 318.32936,258.995 c -70.568,-48.163 -87.607,-119.495 -87.607,-119.495 -1.651,41.519 18.737,87.94 52.761,136.102 44.583,63.109 83.837,104.628 97.335,104.628 13.499,0 64.494,-66.738 64.494,-66.738 0,0 -56.414,-6.335 -126.983,-54.497 z",
    fill: "url(#paint5_linear_9405_17331)",
    id: "path8",
    style: {
      fill: "url(#paint5_linear_9405_17331)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 635.81736,494.808 c 0,0 30.833,-31.746 64.41,-14.652 17.525,9.893 24.113,34.798 24.113,34.798 l 34.193,253.052 c 0,0 12.99,82.204 -93.432,91.268 -100.048,8.524 -107.728,-63.491 -107.728,-63.491 l -25.973,-195.359 z",
    fill: "url(#paint6_radial_9405_17331)",
    id: "path9",
    style: {
      fill: "url(#paint6_radial_9405_17331)"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs74"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9405_17331",
    x: 277.5,
    y: 297.27701,
    width: 573.96899,
    height: 441.68799,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix",
    id: "feFlood16"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape",
    id: "feBlend16"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha",
    id: "feColorMatrix16"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset16"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.4795,
    id: "feGaussianBlur16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    id: "feComposite16",
    k1: 0,
    k4: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.517647 0 0 0 0 0.996078 0 0 0 1 0",
    id: "feColorMatrix17"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9405_17331",
    id: "feBlend17"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_9405_17331",
    x: 278,
    y: 297.492,
    width: 573.50403,
    height: 441.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix",
    id: "feFlood17"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape",
    id: "feBlend18"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha",
    id: "feColorMatrix18"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset18"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.4795,
    id: "feGaussianBlur18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    id: "feComposite18",
    k1: 0,
    k4: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.517647 0 0 0 0 0.996078 0 0 0 1 0",
    id: "feColorMatrix19"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9405_17331",
    id: "feBlend19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9405_17331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(197.19775,262.08119,-283.00876,212.94428,404.197,343.567)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239693,
    stopColor: "#0284FE",
    id: "stop19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553947,
    stopColor: "#065FCE",
    id: "stop20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799302,
    stopColor: "#0360B9",
    id: "stop21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9405_17331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(42.707912,-441.52729,252.86283,24.458836,64.376362,876.418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA8FF",
    id: "stop22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#0284FE",
    id: "stop23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01408F",
    id: "stop24"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9405_17331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(28.763424,-541.72893,584.94007,31.057745,605.56936,379.504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#83C3FE",
    id: "stop25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885417,
    stopColor: "#83C3FE",
    id: "stop26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#4BA7FE",
    id: "stop27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619792,
    stopColor: "#0284FE",
    id: "stop28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0284FE",
    id: "stop29"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9405_17331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-21.682264,190.93384,-359.98631,-40.8797,189.33736,288.693)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCEEFF",
    id: "stop30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#0284FE",
    id: "stop31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_9405_17331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-110.95744,373.00768,-293.31962,-87.252882,491.23936,7.2194)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC6FF",
    id: "stop32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448918,
    stopColor: "#0284FE",
    id: "stop33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825117,
    stopColor: "#0576DB",
    id: "stop34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9405_17331",
    x1: 592.18402,
    y1: 243.72301,
    x2: 533.96301,
    y2: 359.55399,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-243.97664,-14)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E9AFF",
    id: "stop35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEDFFF",
    id: "stop36"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_9405_17331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-51.150895,-518.08303,296.70639,-29.294141,694.57936,871.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA8FF",
    id: "stop37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#0284FE",
    id: "stop38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01408F",
    id: "stop39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLogo);
export default __webpack_public_path__ + "static/media/m_logo.cd5c253ee5a42a27879c26bcb3ef4478.svg";
export { ForwardRef as ReactComponent };